import {
  CommentOutlined,
  DeleteOutlined,
  EditOutlined,
  HistoryOutlined,
  PlusCircleOutlined,
  ScheduleOutlined,
} from '@ant-design/icons';
import { Button, Modal, Space, Tooltip } from 'antd';
import moment from 'moment';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { appointmentConst, appointmentStatus } from '../../../../constants';
import { hexToRGB, stringDate } from '../../../../util';
import { StatusModalBody } from '../StatusModalBody';
import { CustomerModal } from '../../Customer/CustomerModalBody';
import { CancelAppointment } from '../CancelAppointment';
import { clearMissedAppointments } from '../../../../appRedux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { AddCommentModalBody } from '../CommentModal';
import { setAppointmentData } from '../../../../appRedux/actions/General';
import { featureFlags } from '../../../../util/featureFlags';

export const PopoverHeader = ({
  appointment,
  indexTime,
  cabain,
  privileges,
}) => {
  const { selectedBranchId } = useSelector((state) => state.agenda);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [child, setChild] = useState();
  const [width, setWidth] = useState();
  const [modalTittle, setModalTitle] = useState();
  const { customer } = appointment;
  const currentDateTime = `${appointment?.date} ${appointment?.endTime}`;
  const isAfter = moment(currentDateTime).isAfter(moment());
  const { inProcess, scheduled } = appointmentStatus;
  const color = `rgb(${hexToRGB(appointmentStatus[appointment?.status].color)}`;
  const allowedStatus = [scheduled?.alias, inProcess?.alias].includes(
    appointment?.status,
  );

  const getTimeFromIndex = (indexTime) => {
    const firstDash = indexTime.indexOf('-');

    const time = indexTime.substring(0, firstDash);
    const date = indexTime.substring(firstDash + 1);

    return { time, date };
  };

  const onModalOpen = (value, modal) => {
    setIsModalOpen(value);
    switch (modal) {
      case 'status':
        setWidth(1280);
        setModalTitle(
          (appointment?.appliedTreatment ?? appointment?.treatment)?.name,
        );
        setChild(
          <StatusModalBody
            setIsModalOpen={setIsModalOpen}
            appointmentId={appointment?.id}
          />,
        );

        break;
      case 'history':
        setWidth(1400);
        setModalTitle('Historial de cliente');
        setChild(<CustomerModal data={customer} />);

        break;
      case 'cancel':
        setModalTitle('Cancelar cita');
        setWidth(700);
        setChild(
          <CancelAppointment
            id={appointment?.id}
            setIsModalOpen={setIsModalOpen}
            purchasedProductId={appointment?.purchasedProduct?.id}
          />,
        );
        break;
      case 'comment':
        setWidth(600);
        setModalTitle('Comentarios');
        setChild(
          <AddCommentModalBody
            appointment={appointment}
            setIsModalOpen={setIsModalOpen}
          />,
        );
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Space
        size={isAfter && allowedStatus ? 30 : 60}
        style={{
          display: 'flex',
          marginBottom: 8,
          justifyContent: 'start',
          color: `rgb(${hexToRGB(
            appointmentStatus[appointment?.status].color,
          )})`,
        }}
        align="baseline"
      >
        <span>{stringDate(appointment?.date)}</span>
        <div className="appointment buttons">
          <Tooltip title={appointmentConst.TOOLTIPS.CUSTOMER_HISTORY}>
            <Button
              icon={<HistoryOutlined />}
              style={{ color }}
              type="link"
              onClick={() => {
                onModalOpen(true, 'history');
              }}
            />
          </Tooltip>
          {featureFlags.externalAppointment && (
            <Button
              icon={<PlusCircleOutlined />}
              type="link"
              style={{ color }}
              onClick={() => {
                const { time, date } = getTimeFromIndex(indexTime);

                dispatch(
                  setAppointmentData({
                    branchId: selectedBranchId,
                    cabainId: cabain?.id,
                    time,
                    date,
                  }),
                );

                navigate('/dashboard/agenda/crear', {
                  state: { fromPopover: true },
                });
              }}
            />
          )}
          {privileges.includes('edit') && (
            <Tooltip title={appointmentConst.TOOLTIPS.EDIT_APPOINTMENT}>
              <Button
                icon={<EditOutlined />}
                type="link"
                style={{
                  color: `rgb(${hexToRGB(
                    appointmentStatus[appointment?.status].color,
                  )})`,
                }}
                onClick={() => {
                  navigate(`/dashboard/agenda/${appointment?.id}`);
                }}
              />
            </Tooltip>
          )}
          {privileges.includes('edit') && (
            <Tooltip title={appointmentConst.TOOLTIPS.EDIT_OBSERVATIONS}>
              <Button
                icon={<CommentOutlined />}
                type="link"
                style={{
                  color: `rgb(${hexToRGB(
                    appointmentStatus[appointment?.status].color,
                  )})`,
                }}
                onClick={() => {
                  onModalOpen(true, 'comment');
                }}
              />
            </Tooltip>
          )}
          {allowedStatus && (
            <>
              {privileges.includes('edit') && (
                <Tooltip title={appointmentConst.TOOLTIPS.CHANGE_STATUS}>
                  <Button
                    icon={<ScheduleOutlined />}
                    type="link"
                    style={{ color }}
                    onClick={() => {
                      onModalOpen(true, 'status');
                    }}
                  />
                </Tooltip>
              )}
              {privileges.includes('delete') && (
                <Tooltip title={appointmentConst.TOOLTIPS.CANCEL_APPOINTMENT}>
                  <Button
                    icon={<DeleteOutlined />}
                    type="link"
                    style={{
                      color: `rgb(${hexToRGB(
                        appointmentStatus[appointment?.status].color,
                      )})`,
                    }}
                    onClick={() => {
                      onModalOpen(true, 'cancel');
                    }}
                  />
                </Tooltip>
              )}
            </>
          )}
        </div>
      </Space>

      <Modal
        title={modalTittle}
        width={width}
        destroyOnClose={true}
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(!isModalOpen)}
        onOk={() => setIsModalOpen(!isModalOpen)}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { display: 'none' } }}
        afterClose={() => dispatch(clearMissedAppointments())}
      >
        {child}
      </Modal>
    </>
  );
};
